import { parseCsv, detectDelimiter, detectMultiSeparator } from './csvParser.js';
import { parseXlsx, listSheets } from './xlsxParser.js';

const XLSX_EXTS = ['xlsx', 'xls', 'xlsm'];
const CSV_EXTS = ['csv', 'tsv', 'txt'];

export function detectKind(filename) {
  if (!filename || typeof filename !== 'string') return 'unknown';
  const ext = filename.split('.').pop().toLowerCase();
  if (XLSX_EXTS.includes(ext)) return 'xlsx';
  if (CSV_EXTS.includes(ext)) return 'csv';
  return 'unknown';
}

export async function parseFile(file, options = {}, onProgress = () => {}) {
  const kind = options.kind || detectKind(file?.name || options.filename);
  if (kind === 'xlsx') {
    return { kind, ...(await parseXlsx(file, options, onProgress)) };
  }
  if (kind === 'csv') {
    return { kind, ...(await parseCsv(file, options, onProgress)) };
  }
  throw new Error(`Unsupported file kind: ${kind}`);
}

export async function previewSheets(file) {
  const kind = detectKind(file?.name);
  if (kind === 'xlsx') {
    const sheets = await listSheets(file);
    return { kind, sheets };
  }
  return { kind, sheets: [] };
}

export { parseCsv, parseXlsx, detectDelimiter, detectMultiSeparator };
